export const UPDATE_LOCAL_STETHOSCOPES =
  "STETHOSCOPE_FEATURE::UPDATE_LOCAL_STETHOSCOPES";
export const UPDATE_REMOTE_STETHOSCOPES =
  "STETHOSCOPE_FEATURE::UPDATE_REMOTE_STETHOSCOPES";
export const UPDATE_REMOTE_SPEAKER =
  "STETHOSCOPE_FEATURE::UPDATE_REMOTE_SPEAKER";

export const REMOTE_SPEAKER_CHANGES_SUBSCRIBE =
  "STETHOSCOPE_FEATURE::REMOTE_SPEAKER_CHANGES_SUBSCRIBE";
export const REMOTE_SPEAKER_CHANGES_SUBSCRIBE_SUCCEEDED =
  "STETHOSCOPE_FEATURE::REMOTE_SPEAKER_CHANGES_SUBSCRIBE_SUCCEEDED";
export const REMOTE_SPEAKER_CHANGES_SUBSCRIBE_FAILED =
  "STETHOSCOPE_FEATURE::REMOTE_SPEAKER_CHANGES_SUBSCRIBE_FAILED";

export const REMOTE_SPEAKER_CHANGES_UNSUBSCRIBE =
  "STETHOSCOPE_FEATURE::REMOTE_SPEAKER_CHANGES_UNSUBSCRIBE";
export const REMOTE_SPEAKER_CHANGES_UNSUBSCRIBE_SUCCEEDED =
  "STETHOSCOPE_FEATURE::REMOTE_SPEAKER_CHANGES_UNSUBSCRIBE_SUCCEEDED";
export const REMOTE_SPEAKER_CHANGES_UNSUBSCRIBE_FAILED =
  "STETHOSCOPE_FEATURE::REMOTE_SPEAKER_CHANGES_UNSUBSCRIBE_FAILED";

export const SELECT_REMOTE_STETHOSCOPE =
  "STETHOSCOPE_FEATURE::SELECT_REMOTE_STETHOSCOPE";
export const SELECT_REMOTE_STETHOSCOPE_SUCCEEDED =
  "STETHOSCOPE_FEATURE::SELECT_REMOTE_STETHOSCOPE_SUCCEEDED";
export const SELECT_REMOTE_STETHOSCOPE_FAILED =
  "STETHOSCOPE_FEATURE::SELECT_REMOTE_STETHOSCOPE_FAILED";

export const UNSELECT_REMOTE_STETHOSCOPE =
  "STETHOSCOPE_FEATURE::UNSELECT_REMOTE_STETHOSCOPE";
export const UNSELECT_REMOTE_STETHOSCOPE_SUCCEEDED =
  "STETHOSCOPE_FEATURE::UNSELECT_REMOTE_STETHOSCOPE_SUCCEEDED";
export const UNSELECT_REMOTE_STETHOSCOPE_FAILED =
  "STETHOSCOPE_FEATURE::UNSELECT_REMOTE_STETHOSCOPE_FAILED";

export const START_REMOTE_STETHOSCOPE =
  "STETHOSCOPE_FEATURE::START_REMOTE_STETHOSCOPE";
export const START_REMOTE_STETHOSCOPE_SUCCEEDED =
  "STETHOSCOPE_FEATURE::START_REMOTE_STETHOSCOPE_SUCCEEDED";
export const START_REMOTE_STETHOSCOPE_FAILED =
  "STETHOSCOPE_FEATURE::START_REMOTE_STETHOSCOPE_FAILED";

export const STOP_REMOTE_STETHOSCOPE =
  "STETHOSCOPE_FEATURE::STOP_REMOTE_STETHOSCOPE";
export const STOP_REMOTE_STETHOSCOPE_SUCCEEDED =
  "STETHOSCOPE_FEATURE::STOP_REMOTE_STETHOSCOPE_SUCCEEDED";
export const STOP_REMOTE_STETHOSCOPE_FAILED =
  "STETHOSCOPE_FEATURE::STOP_REMOTE_STETHOSCOPE_FAILED";

export const SELECT_LOCAL_STETHOSCOPE =
  "STETHOSCOPE_FEATURE::SELECT_LOCAL_STETHOSCOPE";
export const SELECT_LOCAL_STETHOSCOPE_SUCCEEDED =
  "STETHOSCOPE_FEATURE::SELECT_LOCAL_STETHOSCOPE_SUCCEEDED";
export const SELECT_LOCAL_STETHOSCOPE_FAILED =
  "STETHOSCOPE_FEATURE::SELECT_LOCAL_STETHOSCOPE_FAILED";

export const UNSELECT_LOCAL_STETHOSCOPE =
  "STETHOSCOPE_FEATURE::UNSELECT_LOCAL_STETHOSCOPE";
export const UNSELECT_LOCAL_STETHOSCOPE_SUCCEEDED =
  "STETHOSCOPE_FEATURE::UNSELECT_LOCAL_STETHOSCOPE_SUCCEEDED";
export const UNSELECT_LOCAL_STETHOSCOPE_FAILED =
  "STETHOSCOPE_FEATURE::UNSELECT_LOCAL_STETHOSCOPE_FAILED";

export const UNPROCESSED_AUDIO_UPDATES_SUBSCRIBE =
  "STETHOSCOPE_FEATURE::UNPROCESSED_AUDIO_UPDATES_SUBSCRIBE";
export const UNPROCESSED_AUDIO_UPDATES_SUBSCRIBE_SUCCEEDED =
  "STETHOSCOPE_FEATURE::UNPROCESSED_AUDIO_UPDATES_SUBSCRIBE_SUCCEEDED";
export const UNPROCESSED_AUDIO_UPDATES_SUBSCRIBE_FAILED =
  "STETHOSCOPE_FEATURE::UNPROCESSED_AUDIO_UPDATES_SUBSCRIBE_FAILED";

export const UNPROCESSED_AUDIO_UPDATES_UNSUBSCRIBE =
  "STETHOSCOPE_FEATURE::UNPROCESSED_AUDIO_UPDATES_UNSUBSCRIBE";
export const UNPROCESSED_AUDIO_UPDATES_UNSUBSCRIBE_SUCCEEDED =
  "STETHOSCOPE_FEATURE::UNPROCESSED_AUDIO_UPDATES_UNSUBSCRIBE_SUCCEEDED";
export const UNPROCESSED_AUDIO_UPDATES_UNSUBSCRIBE_FAILED =
  "STETHOSCOPE_FEATURE::UNPROCESSED_AUDIO_UPDATES_UNSUBSCRIBE_FAILED";

export const LOCAL_STETHOSCOPE_STARTED =
  "STETHOSCOPE_FEATURE::LOCAL_STETHOSCOPE_STARTED";
export const LOCAL_STETHOSCOPE_STOPPED =
  "STETHOSCOPE_FEATURE::LOCAL_STETHOSCOPE_STOPPED";

export const STETHOSCOPE_SUPPORT_CHANGED =
  "STETHOSCOPE_FEATURE::STETHOSCOPE_SUPPORT_CHANGED";

export const SELECTED_REMOTE_STETHOSCOPE_REMOVED =
  "STETHOSCOPE_FEATURE::SELECTED_REMOTE_STETHOSCOPE_REMOVED";

export const ENABLE_DYNAMIC_AUDIO_SOURCES =
  "STETHOSCOPE_FEATURE::ENABLE_DYNAMIC_AUDIO_SOURCES";
export const ENABLE_DYNAMIC_AUDIO_SOURCES_SUCCEEDED =
  "STETHOSCOPE_FEATURE::ENABLE_DYNAMIC_AUDIO_SOURCES_SUCCEEDED";
export const ENABLE_DYNAMIC_AUDIO_SOURCES_FAILED =
  "STETHOSCOPE_FEATURE::ENABLE_DYNAMIC_AUDIO_SOURCES_FAILED";

export const DISABLE_DYNAMIC_AUDIO_SOURCES =
  "STETHOSCOPE_FEATURE::DISABLE_DYNAMIC_AUDIO_SOURCES";
export const DISABLE_DYNAMIC_AUDIO_SOURCES_SUCCEEDED =
  "STETHOSCOPE_FEATURE::DISABLE_DYNAMIC_AUDIO_SOURCES_SUCCEEDED";
export const DISABLE_DYNAMIC_AUDIO_SOURCES_FAILED =
  "STETHOSCOPE_FEATURE::DISABLE_DYNAMIC_AUDIO_SOURCES_FAILED";
